const SNACKBAR = {
    SUCCESS: {
        variant: 'success',
        iconName: 'check_circle',
    },
    ERROR: {
        variant: 'error',
        iconName: 'error',
    },
    INFO: {
        variant: 'info',
        iconName: 'error',
    },
};

export default SNACKBAR;



// WEBPACK FOOTER //
// ./src/enums/Snackbar.js